import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ReactiveFormsModule, FormControl, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { Router, RouterModule } from "@angular/router";
import { KeycloakService } from "keycloak-angular";
import { getRedirectUri } from "src/app/core/keycloak/keycloak.utils";
import { environment } from "src/environments/environment";
import { UnleashService } from "../../services/unleash.service";
import { Observable } from "rxjs";

@Component({
  selector: "myqq-unauth-header",
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    RouterModule,
    ReactiveFormsModule,
    MatInputModule,
  ],
  templateUrl: "./unauth-header.component.html",
  styleUrl: "./unauth-header.component.scss",
})
export class UnauthHeaderComponent {
  constructor(
    private router: Router,
    readonly keycloakSvc: KeycloakService,
    private readonly unleashService: UnleashService
  ) {}
  readonly enableFriendBuy$: Observable<boolean> = this.unleashService
    .enableFriendBuy$;

  showSupportMenu = false;
  showMyQQMenu = false;
  showMobileMenu = false;
  cdnHost = environment.cdnHost;
  whyMembershipLink = "/why-membership";
  whyQQLink = "/why-qq";
  FAQsLink = "/faq";
  email = "info@dontdrivedirty.com";
  blogLink = "https://www.dontdrivedirty.com/blog/";
  careerLink = "/jobs";
  handleLocationsSearch() {
    this.router.navigate(["/locations"], {
      queryParams: { zipcode: this.zipcode.value },
    });
  }

  handlePlansSearch() {
    this.router.navigateByUrl(`/plans/${this.zipcode.value}`);
  }

  handleRegister() {
    const { redirectUri } = getRedirectUri();
    this.keycloakSvc.register({
      redirectUri: redirectUri,
    });
  }

  handleLogin() {
    const { redirectUri } = getRedirectUri();
    const options = environment.keycloak.loginOptions;
    options.redirectUri = redirectUri;
    this.keycloakSvc.login(options);
  }

  toggleSupportMenu() {
    this.showSupportMenu = !this.showSupportMenu;
  }

  toggleMyQQMenu() {
    this.showMyQQMenu = !this.showMyQQMenu;
  }

  toggleMobileMenu() {
    this.showMobileMenu = !this.showMobileMenu;
  }
  zipcode = new FormControl("", [
    Validators.required,
    Validators.minLength(5),
    Validators.maxLength(5),
  ]);
}
